<template lang="pug">
v-row
  v-col(cols=12 lg=5 v-if="!selectedTrip && ((mobile && !showMap) || !mobile)")
    v-card(class="pa-2" fill-height )
        div.text-h6 Trips that start near
        AddressFinder(:model="nearLocation" :clear="true")
    div(class="full-height-div")
      RoadTripCard(v-if="sortedTrips != null" v-for="trip of sortedTrips" :key="trip.id" :trip="trip" @clicked="selectTrip(trip)")
      v-container(bg fill-height text-xs-center v-if="sortedTrips == null")
        v-layout(row wrap align-center justify-center)
          v-flex(style="text-align: center;")
            v-progress-circular(color="pink" indeterminate)
  v-col(cols=12 lg=5 v-if="selectedTrip && ((mobile && !showMap) || !mobile)")
    v-btn(small @click="selectedTrip = null" class="ma-2 primary") 
      v-icon mdi-chevron-left
      span See other trips
    div(style="height: 89vh; overflow-y: auto")
      v-card(class="pa-2")
        v-img(class="white--text align-end" height="200px" :src=" 'data:image/png;base64, ' + selectedTrip.PhotoData")
          v-card-title {{ selectedTrip.Name }}
        v-card-text {{ selectedTrip.Details }}
        RoadTripStep(v-for="(point,index) of selectedTrip.waypoints" :key="index" :waypoint="point")

  v-col(cols=12 lg=7  )
    RoadTripMap(v-if="(mobile && showMap) || !mobile" :roadTrips="tripData" :selectedTrip="selectedTrip" @tripSelected="selectTrip" :chargers="chargers")


</template> 

<script>
import PowerTrip from "../services/api/PowerTrip.js";
import RoadTripCard from "../components/RoadTripCard.vue";
import AddressFinder from "../components/AddressFinder.vue";
import RoadTripMap from "../components/RoadTripMap.vue";
import RoadTripStep from "../components/RoadTripStep.vue";
import { headerBus } from "../main";
export default {
  data() {
    return {
      tripData: null,
      modelData: [],
      mapVisible: false,
      car: null,
      nearLocation: { Address: null },
      selectedTrip: null,
      chargers: []
    };
  }, 
    created() {
           headerBus.$on('toggleMap', ()=> {
            this.mapVisible = !this.mapVisible;
        });
  },
  computed: {
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
        case "md":
          return true;
        default:
          return false;
      }
    },
        showMap() {
      if (this.$vuetify.breakpoint.name == "lg") {
        return true;
      }
      return this.mapVisible;
    },
    sortedTrips() {
      if (this.nearLocation.Address != null && this.tripData != null) {
        let copy = [];
        let coord = {
          lat: this.nearLocation.Address.geometry.coordinates[1],
          lng: this.nearLocation.Address.geometry.coordinates[0]
        };

        for (let i = 0; i < this.tripData.length; i++) {
          copy.push(this.tripData[i]);
        }
        copy.sort((a, b) => {
          let aLocation = this.getTripLocation(a);
          let bLocation = this.getTripLocation(b);
          if (
            this.haversineDistance(aLocation, coord) <
            this.haversineDistance(bLocation, coord)
          ) {
            return -1;
          } else {
            return 1;
          }
        });
        return copy;
      }

      return this.tripData;
    }
  },
  methods: {
    updateSelected() {},
   
    selectTrip(trip) {
      this.selectedTrip = trip;
      this.selectedTrip.waypoints = JSON.parse(trip.WaypointData);
    }
  },
  mounted: function() {
    PowerTrip.getTrips().then(response => (this.tripData = response.data));
     PowerTrip.getChargingStations().then((stations) => {
      this.chargers = stations;
    });
  },
  components: {
    RoadTripCard,
    RoadTripMap,
    AddressFinder,
    RoadTripStep
  }
};
</script>

<style  scoped>
.full-height-div {
  height: calc(100vh - 180px); /* Adjust 270px to suits your needs */
  width:100%;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>